import React from "react";
import MetaDecorator from "../../components/MetaDecorator/MetaDecorator";
import { privacyban, privacybanmob } from "../../images";
import "./cookiepolicy.scss";

const CookiePolicy = () => {
  const bannerArr = [
    {
      id: 1,
      img: privacyban,
      mobimg: privacybanmob,
      firsthead: "Home | Cookie Policy",
      desc: "",
    },
  ];

  const privacyArr = [
    {
      desc: "<Strong>Last updated on</strong>: 14th October, 2022.",
    },
    {
      desc: "Cookies are text files containing small amounts of information which are downloaded to your device when you visit a website. The primary role of cookies is to make the interaction between users and websites faster and easier. Our website (www.raymond.in) (“Website”) uses cookies (our own and/or of third-parties) for various reasons which we will explain in this policy. However, we use cookies primarily to make your overall experience of our Website better and to improve our Website.",
    },
    {
      heading: "IMPORTANT NOTE:",
      desc: "<ul><li>Upon first visiting our Website, you will see a pop up message seeking your acceptance on our cookies policy. Although the pop up message will not usually appear on subsequent visits, you can still change your cookies preferences by changing your browser settings. However, if you decline our cookies settings, you may not be able to access all our Website features.</li><li>By continuing to use our Website you are agreeing to our use of cookies policy.</li><li>For more information and for details about how to block or control cookies, please see <a href='/cookie-policy'>AboutCookies.org</a>.</li></ul>",
    },
    {
      heading: "Purpose we use cookies for:",
      desc: "We use cookies mainly to:<ul><li>Gather data about your visits to our Website, including numbers of visitors and visits, length of time spent on the site, pages clicked on or where visitors have come from;</li><li>To recognize you when you return to our Website, remember usernames, language preferences and regions, which can be used to provide more personalized services. This allows users to customize how the Website looks for them;</li><li>To help remember information that helps users with navigation across Website pages;</li><li>To deliver interest based or targeted advertisements based on the users browsing activities over time and to limit the number of times you see an advertisement. The advertising networks on whose behalf the cookies are placed may use these cookies to build a profile of your interest and deliver relevant and meaningful advertisements; and</li><li>To help measure the effectiveness of the advertising campaign by determining how the served ads performed or by gathering information about how the users interacts with those ads.</li></ul>",
    },
    {
      heading: "Types of Cookies we use:",
      desc: "You can find more information about the individual cookies we use and the purposes for which we use them in the table below:<br /><br /><strong>Essential or Necessary</strong>: Essential or Necessary cookies are used to operate the core functions of our Website, so that you may visit and move around it, and use its features. The Website cannot function properly without these cookies.<br /><br /><div class='table_wrapper'><table class='GeneratedTable' width='100%'> <thead> <tr> <th>Cookie Name</th> <th>Provider (Own or Third Party)</th> <th>Purpose</th> <th>Duration / Expiry</th> <th>Type</th> </tr> </thead> <tbody> <tr> <td>Nil</td> <td>Nil</td><td>Nil</td><td>Nil</td><td>Nil</td> </tr> </tbody> </table></div><br /><strong>Preferences</strong>: Preference cookies enable a website to remember information that changes the way the website behaves or looks, like your preferred language or the region that you are in.<br /><br /><div class='table_wrapper'><table class='GeneratedTable' width='100%'> <thead> <tr> <th>Cookie Name</th> <th>Provider (Own or Third Party)</th> <th>Purpose</th> <th>Duration / Expiry</th> <th>Type</th> </tr> </thead> <tbody> <tr> <td>Nil</td> <td>Nil</td><td>Nil</td><td>Nil</td><td>Nil</td> </tr> </tbody> </table></div><br /><strong>Analytics or Statistics</strong>: Analytics or Statistic cookies help website owners to understand how visitors interact with websites by collecting and reporting information anonymously.<br /><br /><div class='table_wrapper'><table class='GeneratedTable' width='100%'> <thead> <tr> <th>Cookie Name</th> <th>Provider (Own or Third Party)</th> <th>Purpose</th> <th>Duration / Expiry</th> <th>Type</th> </tr> </thead> <tbody> <tr> <td>Nil</td> <td>Nil</td><td>Nil</td><td>Nil</td><td>Nil</td> </tr> </tbody> </table></div><br /><strong>Marketing or Targeting</strong>: Marketing or Targeting cookies are used to track visitors across websites. The intention is to display ads that are relevant and engaging for the individual user and thereby more valuable for publishers and third party advertisers.<br /><br /><div class='table_wrapper'><table class='GeneratedTable' width='100%'> <thead> <tr> <th>Cookie Name</th> <th>Provider (Own or Third Party)</th> <th>Purpose</th> <th>Duration / Expiry</th> <th>Type</th> </tr> </thead> <tbody> <tr> <td>Nil</td> <td>Nil</td><td>Nil</td><td>Nil</td><td>Nil</td> </tr> </tbody> </table></div><br /><strong>Contacts us</strong>: You can at any time change or withdraw your consent by contacting us on the details as mentioned in our <a href='/privacy-policy' target='_blank'><strong>Privacy Policy</strong></a>.",
    },
  ];

  const bannerList = bannerArr.map((item, i) => (
    <>
      <div className="text_container">
        <div className="breadcrumb">{item.firsthead}</div>
        <div className="heading">Cookie Policy</div>
        <div className="desc">{item.desc}</div>
      </div>
      <img
        src={item.img}
        alt="raymond Brand img"
        className="mainimg"
        loading="lazy"
        width="100%"
        height="100%"
      />
    </>
  ));

  return (
    <>
      <MetaDecorator metaTitle="Welcome to Raymond | Cookie Policy" />
      <section className="privacy_sec1">
        <div className="my_container">{bannerList}</div>
      </section>

      <section className="privacy_sec2">
        <div className="my_container">
          <div className="text_container">
            {privacyArr.map(({ heading, desc }) => (
              <>
                <h4 className="heading">{heading}</h4>
                <p
                  className="desc"
                  dangerouslySetInnerHTML={{
                    __html: desc.replace(/(<? * script)/gi, "illegalscript"),
                  }}
                ></p>
              </>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default CookiePolicy;
